import { useLocation, useNavigate } from 'react-router-dom';
import { useNavigateStore } from '../../Containers/MainContainer/Store/NavigateStore';

const useCustomNavigate = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const { setNavigateStore, title } = useNavigateStore();

    const customNavigate = (url, mainTitle, state, selectedMenu) => {
        navigate(url, { state: { riskDetails: state?.id, selectedMenu: selectedMenu } });
        setNavigateStore(mainTitle, { prevRoute: location.pathname, prevTitle: title });
    };

    return customNavigate;
};

export default useCustomNavigate;